(function() {
    'use strict';

    /**
     * Central helpers for window.postMessage: never use targetOrigin '*'.
     * Parent targets: derived from ancestorOrigins / referrer and validated against a hostname policy
     * plus optional window.__ATH_ALLOWED_PARENT_POST_MESSAGE_ORIGINS__ (array of full origin strings).
     */

    angular
        .module('atheer.core')
        .factory('postMessageSecurity', postMessageSecurity);

    postMessageSecurity.$inject = ['$window', '$log'];

    function postMessageSecurity($window, $log) {
        return {
            getNgxIframeTargetOrigin: getNgxIframeTargetOrigin,
            getParentTargetOrigin: getParentTargetOrigin,
            postMessageToParent: postMessageToParent,
            isTrustedGoodDataEmbedOrigin: isTrustedGoodDataEmbedOrigin,
            parseOriginFromBaseUrl: parseOriginFromBaseUrl,
            isTrustedFirstPartyEmbedOrigin: isTrustedFirstPartyEmbedOrigin,
            parseTrustedEmojiPickerMessage: parseTrustedEmojiPickerMessage
        };

        function getNgxIframeTargetOrigin() {
            var loc = $window.location;
            if (loc.hostname === 'localhost') {
                return 'https://' + loc.hostname + ':4200';
            }
            return loc.origin;
        }

        function parseOriginFromBaseUrl(baseUrl) {
            if (!baseUrl || !angular.isString(baseUrl)) {
                return null;
            }
            var s = baseUrl.trim();
            if (!/^https?:\/\//i.test(s)) {
                s = 'https://' + s.replace(/^\/\//, '');
            }
            try {
                return new URL(s).origin;
            } catch (e) {
                return null;
            }
        }

        function isTrustedParentHostname(hostname) {
            if (!hostname) {
                return false;
            }
            if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]') {
                return true;
            }
            return /^(.+\.)?atheer\.(dev|my)$/i.test(hostname);        
        }

        function isOriginInExplicitAllowlist(origin) {
            var extra = $window.__ATH_ALLOWED_PARENT_POST_MESSAGE_ORIGINS__;
            if (!angular.isArray(extra)) {
                return false;
            }
            for (var i = 0; i < extra.length; i++) {
                if (extra[i] === origin) {
                    return true;
                }
            }
            return false;
        }

        function isTrustedParentOrigin(origin) {
            if (!origin || !angular.isString(origin)) {
                return false;
            }
            if (isOriginInExplicitAllowlist(origin)) {
                return true;
            }
            try {
                var host = new URL(origin).hostname;
                return isTrustedParentHostname(host);
            } catch (e) {
                return false;
            }
        }

        function collectParentOriginCandidates() {
            var out = [];
            var seen = {};

            function push(o) {
                if (o && !seen[o]) {
                    seen[o] = true;
                    out.push(o);
                }
            }

            if ($window.location.ancestorOrigins && $window.location.ancestorOrigins.length) {
                push($window.location.ancestorOrigins[0]);
            }
            if ($window.document.referrer) {
                var fromRef = parseOriginFromBaseUrl($window.document.referrer);
                push(fromRef);
            }
            return out;
        }

        function getParentTargetOrigin() {
            var candidates = collectParentOriginCandidates();
            for (var i = 0; i < candidates.length; i++) {
                if (isTrustedParentOrigin(candidates[i])) {
                    return candidates[i];
                }
            }
            return null;
        }

        function postMessageToParent(message) {
            if ($window.parent === $window) {
                return;
            }
            var target = getParentTargetOrigin();
            if (!target) {
                $log.warn('postMessageSecurity: no trusted parent origin; message not sent.');
                return;
            }
            $window.parent.postMessage(message, target);
        }

        function isTrustedGoodDataEmbedOrigin(embedOrigin, hostUri) {
            if (!embedOrigin || !hostUri) {
                return false;
            }
            var expected = parseOriginFromBaseUrl(hostUri);
            if (!expected) {
                return false;
            }
            return embedOrigin === expected;
        }

        /**
         * first-party embeds (e.g. third-party/emoji iframe) are same-origin as the shell.
         */
        function isTrustedFirstPartyEmbedOrigin(origin) {
            return !!(origin && angular.isString(origin) && origin === $window.location.origin);
        }

        /**
         * Strict shape for postMessage payloads from the bundled emoji picker (emojiSelected + emoji).
         * Returns a minimal safe object or null.
         */
        function parseTrustedEmojiPickerMessage(data) {
            if (data == null || typeof data !== 'object' || data.emojiSelected !== true) {
                return null;
            }
            var emoji = data.emoji;
            if (emoji == null || typeof emoji !== 'object') {
                return null;
            }
            if (typeof emoji.native !== 'string' || typeof emoji.unified !== 'string') {
                return null;
            }
            if (emoji.native.length > 128 || emoji.unified.length > 256) {
                return null;
            }
            return { native: emoji.native, unified: emoji.unified };
        }
    }
})();
